import { loadStripe } from '@stripe/stripe-js';

// Create a singleton Stripe instance to prevent multiple initializations
let stripePromise = null;

export const getStripePromise = () => {
  if (!stripePromise && process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY) {
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};

// Clean up function for when component unmounts
export const cleanupStripe = () => {
  stripePromise = null;
};
